// analytics.ts
import ReactGA from "react-ga4";

type TrackEventOptions = {
  gaEvent?: string;
  clarityEvent?: string;
  params?: Record<string, any>;
};

export const trackEvent = ({
  gaEvent,
  clarityEvent,
  params = {},
}: TrackEventOptions) => {
  // GA4
  if (gaEvent) {
    ReactGA.event(gaEvent, params);
  }

  // Clarity
  if (
    clarityEvent &&
    typeof window !== "undefined" &&
    (window as any).clarity
  ) {
    (window as any).clarity("event", clarityEvent);
  }
};